import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;

  & > *:last-child {
    margin-left: 15px;
  }
`;

export const Content = styled.div`
  width: 100%;
  margin-top: 40px;
`;

export const MainTitle = styled.h1`
  margin-top: 15px;
  margin-bottom: 25px;
`;
